<div class="multicard"><hotm-card *ngFor="let card of cards; let num = index" [card]="card" [selected]="num === selectedCard" (click)="selectCard(num)"></hotm-card></div>
<div class="actions">
	<div *ngIf="selectedCard != null && cards[selectedCard].cardType !== cardType.event">
		<strong>{{ cardStatsString }} {{ cardTotal }}</strong>
		<strong [ngClass]="{'hidden': !cardRoll}">{{ cardRollString }}</strong>
	</div>
	<div *ngIf="cards.length > 1">
		<p>
			<strong>Select a card to use; the other{{ cards.length > 2 ? 's' : '' }} will be discarded</strong>
			<button [disabled]="selectedCard == null" (click)="proceedWithCard()">Proceed with {{ selectedCard == null ? 'This Card' : cards[selectedCard].cardName }}</button>
		</p>
	</div>
	<div *ngIf="cards.length === 1">
		<div *ngIf="cards[0].cardType === cardType.event">
			<p>
				<button (click)="doEvent.emit()">Close</button>
			</p>
		</div>
		<div *ngIf="cards[0].cardType !== cardType.event">
			<p *ngIf="!playerRoll">
				<button *ngIf="cards[0].cardType === cardType.enemy" (click)="fightCard()">Fight Enemy</button>
				<button *ngIf="cards[0].cardType === cardType.trap" (click)="fightCard()">Disarm Trap</button>
				<button *ngIf="cards[0].cardType === cardType.heart" (click)="fightCard()">Battle Dragon</button>
			</p>
			<p *ngIf="playerRoll && !playerWin">
				<button (click)="lostFight()">You Lose!</button>
			</p>
			<p *ngIf="playerWin">
				<strong>You Win!</strong>
				<button *ngIf="!newItem && cards[0].cardType !== cardType.heart" (click)="newItem = true">Take Item</button>
				<button *ngIf="!newItem && cards[0].cardType !== cardType.heart" (click)="saveForXP()">Save for XP</button>
				<button *ngIf="cards[0].cardType === cardType.heart" (click)="gameService.turnStep = 10">Close</button>
			</p>
		</div>
	</div>
	<div *ngIf="selectedCard != null && cards[selectedCard].cardType !== cardType.event">
		<strong>{{ playerStatsString }} {{ playerTotal }}</strong>
		<strong [ngClass]="{'hidden': !playerRoll}">{{ playerRollString }}</strong>
	</div>
</div>
<hotm-player [player]="player" [playerNum]="playerNum" [zoomed]="true" class="player{{ playerNum }} myTurn" [gainingItem]="newItem" (wounded)="wounded.emit()" (discardCard)="discardCard.emit($event)" (useCard)="useCard.emit($event)" (cardPower)="useItemPower($event)"></hotm-player>
